import { gql } from '@apollo/client';

import { AuthTokensFragment } from '../fragments';

export const ResetPasswordMutation = gql`
    mutation ResetPassword($token: String!, $newPassword: String!) {
        resetPassword(token: $token, newPassword: $newPassword) {
            ...AuthTokens
        }
    }
    ${AuthTokensFragment}
`;
